import $ from "jquery";

$(document).ready(function () {
  document
    .getElementById("dynamicModal")
    .addEventListener("hidden.bs.modal", function (e) {
      this.querySelector(".modal-content").innerHTML = "";
    });

  var modalNf = document.getElementById("modal_nf");
  if (modalNf) {
    modalNf.addEventListener("show.bs.modal", function (event) {
      const button = event.relatedTarget;
      const lot_rate = button.getAttribute("data-lot-rate");
      const lot = button.getAttribute("data-lot");
      const url_rate =
        "/gerenciador-financeiro/lote_rate/" + lot_rate + "/nota_fiscal";

      const modalTitle = modalNf.querySelector(".modal-title");
      const modalForm = modalNf.querySelector(".modal-body form");
      const lotRateInvoice = modalNf.querySelector(
        ".modal-body .lot_rate_invoice",
      );

      if (modalTitle)
        modalTitle.textContent = "Editar NF da taxa do lote " + lot;
      if (modalForm) modalForm.setAttribute("action", url_rate);
      if (lotRateInvoice) lotRateInvoice.value = "";
    });
  }

  window.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelector("#form_update_lot_rate");

    if (element) {
      element.addEventListener("ajax:success", (event) => {
        const [_data, _status, xhr] = event.detail;
        const modal = document.getElementById("modal_nf");
        if (modal) {
          const bsModal =
            bootstrap.Modal.getInstance(modal) || new bootstrap.Modal(modal);
          bsModal.hide();
        }
      });
      element.addEventListener("ajax:error", () => {
        element.insertAdjacentHTML("beforeend", "<p>ERROR</p>");
      });
    }
  });
});
